'use client';

import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';

import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import { NextImage } from '~components/NextImage/NextImage';
import LinkIcon from '~public/static/images/icons/arrows/Link.svg';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './ArticleCardBig.module.scss';
import { ArticleCardBigProps } from './ArticleCardBig.types';

export function ArticleCardBig({
  className,
  title,
  text,
  categories,
  image,
  href,
  imagePosition = ArticleCardImagePosition.Top,
  publishedAt,
}: ArticleCardBigProps) {
  return (
    <article
      className={classNames(
        className,
        styles.card,
        imagePosition === ArticleCardImagePosition.Bottom &&
          styles.imagePositionBottom,
      )}
    >
      {!publishedAt && <CardDraftLabel />}
      {image && (
        <div className={styles.media}>
          <NextImage className={styles.image} {...image} />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.contentText}>
          {!!categories?.length &&
            categories.map((category) => (
              <Typography
                tagName={TypographySizes.div}
                mods={[TypographyMods.captionSAlt]}
                className={styles.category}
                key={category.id}
              >
                {category.title}
              </Typography>
            ))}

          <Typography
            className={styles.title}
            tagName={TypographySizes.h3}
            mods={[TypographyMods.titleXl]}
          >
            {title}
          </Typography>
          {text && (
            <Typography
              tagName={TypographySizes.p}
              mods={[TypographyMods.bodyM]}
              className={styles.text}
            >
              {text}
            </Typography>
          )}
        </div>
        <div className={styles.linkContainer}>
          <Link className={styles.link} href={href}>
            <LinkIcon className={styles.linkIcon} />
          </Link>
        </div>
      </div>
    </article>
  );
}
